import isJest from './isJest'

export default !isJest && process.env.APP_ENV !== 'development'
